var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.show,
          expression: "show",
        },
      ],
      staticClass: "hide",
      attrs: { "element-loading-background": "rgba(255, 255, 255, 100)" },
    },
    [
      _c("editor", {
        attrs: { init: _vm.init, disabled: _vm.disabled },
        on: { onClick: _vm.onClick },
        model: {
          value: _vm.myValue,
          callback: function ($$v) {
            _vm.myValue = $$v
          },
          expression: "myValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }